import { Table } from '@wework/dieter-ui'
import currencyFormatter from 'currency-formatter'
import _ from 'lodash'

import React from 'react'

export default function HeldSpaces({ spaces }) {
  const attributes = [
    { label: 'Type', value: true },
    { label: 'Seats', value: true },
    { label: 'Capacity', value: true },
    { label: 'Price', value: true },
  ]

  if (spaces.length === 0 || !spaces) {
    return <div></div>
  }

  const getTotalPriceText = (spaces = []) => {
    const totalPrice = _.sumBy(spaces, 'reservable.price')
    const currency = _.get(spaces, '[0].reservable.currency', '')
    const totalPriceText = currencyFormatter.format(totalPrice, {
      code: currency,
    })
    return totalPriceText
  }

  const totalDesks = spaces.reduce((a, b) => a + (b?.metrics.desks || 0), 0)
  const totalCapacity = spaces.reduce(
    (a, b) => a + (b?.reservable?.capacity || 0),
    0
  )
  const totalPrice = getTotalPriceText(spaces)
  return (
    <div>
      <Table singleLine className="unbordered-table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Number</Table.HeaderCell>
            {attributes.map((attribute, index) => {
              if (attribute.value) {
                return (
                  <Table.HeaderCell key={index}>
                    {attribute.label}
                  </Table.HeaderCell>
                )
              }
              return null
            })}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {spaces?.map((space, index) => {
            return (
              <Table.Row key={index}>
                <Table.Cell>{space.number}</Table.Cell>
                {attributes[0].value && (
                  <Table.Cell>{space.subType}</Table.Cell>
                )}
                {attributes[1].value && (
                  <Table.Cell>{space.metrics.desks}</Table.Cell>
                )}
                {attributes[2].value && (
                  <Table.Cell>{space.reservable?.capacity}</Table.Cell>
                )}
                {attributes[3].value && (
                  <Table.Cell>
                    {currencyFormatter.format(space.reservable.price, {
                      code: space.reservable.currency,
                    })}
                  </Table.Cell>
                )}
              </Table.Row>
            )
          })}
        </Table.Body>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Total</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
            {attributes[1].value && (
              <Table.HeaderCell>{totalDesks}</Table.HeaderCell>
            )}
            {attributes[2].value && (
              <Table.HeaderCell>{totalCapacity}</Table.HeaderCell>
            )}
            {attributes[3].value && (
              <Table.HeaderCell>{totalPrice}</Table.HeaderCell>
            )}
          </Table.Row>
        </Table.Header>
      </Table>
    </div>
  )
}
